import script from "./FormUndanews.vue?vue&type=script&setup=true&lang=js"
export * from "./FormUndanews.vue?vue&type=script&setup=true&lang=js"

import "./FormUndanews.vue?vue&type=style&index=0&id=5176f106&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5176f106"]])

export default __exports__